import posthog from 'posthog-js';

export const getPosthogRequestHeaders = (): Record<string, string> => {
  try {
    // An empty explicit header also suppresses Rails' legacy cookie fallback.
    if (posthog.has_opted_out_capturing?.()) {
      return { 'X-Posthog-Session-Id': '' };
    }
    if (!posthog.get_session_id?.()) return { 'X-Posthog-Session-Id': '' };

    const headers: Record<string, string> = {};
    // The public callback immediately supplies the current pair. Never share a
    // window ID through cookies or cache it across requests/session changes.
    const unsubscribe = posthog.onSessionId?.((sessionId, windowId) => {
      if (sessionId) {
        headers['X-Posthog-Session-Id'] = sessionId;
        if (windowId) headers['X-Posthog-Window-Id'] = windowId;
      }
    });
    unsubscribe?.();
    return headers['X-Posthog-Session-Id']
      ? headers
      : { 'X-Posthog-Session-Id': '' };
  } catch {
    return { 'X-Posthog-Session-Id': '' };
  }
};
